import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.classList.add("translate-x-full", "opacity-0")

    requestAnimationFrame(() => {
      this.element.classList.remove("translate-x-full", "opacity-0")
    })

    setTimeout(() => {
      this.dismiss()
    }, 4000)
  }

  dismiss() {
    this.element.classList.add("translate-x-full", "opacity-0")

    setTimeout(() => {
      this.element.remove()
    }, 300)
  }
}
